export default __webpack_public_path__ + "static/media/Paper.9ef50e0a.png";